import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.059 8.138 1.863 2.943 2.806 2l5.195 5.195L13.197 2l.942.943-5.195 5.195 5.195 5.195-.942.943L8 9.081l-5.195 5.195-.943-.943z"
    }, null, -1)
  ]))]))
}
export default { render: render }